export const organizationSelectedSaga = (state) => state.merchantReducer.organizationSelected;
export const brandListSaga = (state) => state.merchantReducer.brandList;
export const apiLoadingSaga = (state) => state.merchantReducer.apiLoading;
export const storeListSaga = (state) => state.merchantReducer.storesList;
export const storeDetailsSaga = (state) => state.merchantReducer.storeDetails;
export const merchantAccessTokenSaga = (state) => state.merchantReducer.merchantAccessToken;
export const brandIDSelectedSaga = (state) => state.merchantReducer.brandIDSelected;
export const appOrganizationSaga = (state) => state.merchantReducer.appOrganization;
export const apiLoadingStatusSaga = (state) => state.merchantReducer.apiLoadingStatus;
export const initialRouteSaga = (state) => state.merchantReducer.initialRoute;
export const storeConnectionStatusSaga = (state) => state.merchantReducer.storeConnectionStatus;
export const storeConnectionSaga = (state) => state.merchantReducer.storeConnection;
export const storeCountListSaga = (state) => state.merchantReducer.storeCountList;
export const appTokenSaga = (state) => state.merchantReducer.appToken;
export const mixPanelDataSaga = (state) => state.merchantReducer.mixPanelData;
export const selectedBrandDetailsSaga = (state) => state.merchantReducer.selectedBrandDetails;
